import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
import { DialogWindowState } from '../../store/schema/DialogWindowState';

export let toggleEditAccountWindow = mutatorAction(
    'toggleEditAccountWindow',
    (state: DialogWindowState) => {
        let store = connectedAccountsStore();
        store.dialogWindowState.editAccountOpen = state.editAccountOpen;
    }
);
